import { render } from "./ServicesFooter.vue?vue&type=template&id=819d7c8c&scoped=true&ts=true"
import script from "./ServicesFooter.vue?vue&type=script&lang=ts"
export * from "./ServicesFooter.vue?vue&type=script&lang=ts"

import "./ServicesFooter.vue?vue&type=style&index=0&id=819d7c8c&scoped=true&lang=scss"

import exportComponent from "/home/app/mt-partners/frontend/affiliate/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-819d7c8c"]])

export default __exports__